 import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../Screenss/DataContext";
const PrincipalMessage = () => {
  const primaryColor = "rgb(0,111,47)";
const { data } = useContext(DataContext);
 const [current, setCurrent] = useState(0);
const galleryItems = data.filter(
    (item) => item.category === "ourschool"
  );

  // 🔁 Auto Slide
  useEffect(() => {
    if (galleryItems.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === galleryItems.length - 1 ? 0 : prev + 1
      );
    }, 3000); // 3 sec

    return () => clearInterval(interval);
  }, [galleryItems]);
  return (
    <div style={{ fontFamily: "sans-serif", background: "#f8fafc" }}>
      
      {/* 🔥 HERO BANNER */}
       <section style={styles.hero}>
        <div style={styles.heroImageWrap}>
          
          {galleryItems.length > 0 && (
            <img
              src={galleryItems[current].full_url}
              alt="school banner"
              style={styles.heroImage}
            />
          )}

          <div style={styles.heroOverlay} />

          {/* <div style={styles.heroContent}>
            <h1 style={styles.heroTitle}>
              Building Foundations That Last a Lifetime
            </h1>
            <p style={styles.heroText}>
              A school is more than walls and textbooks — it is where futures are shaped, values are rooted, and dreams take flight.
            </p>
          </div> */}

          {/* ✅ Dots Indicator */}
          <div style={styles.dots}>
            {galleryItems.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  backgroundColor:
                    current === i ? "rgb(0,111,47)" : "#fff",
                }}
              />
            ))}
          </div>

        </div>
      </section>

      {/* 🔥 MAIN SECTION */}
      <div style={styles.container}>

        <div style={styles.row}>
          
          {/* 👩‍🏫 LEFT IMAGE */}
          <div style={styles.imageWrapper}>
            <img
              src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1776679739_69e5fb3b0ee86.jpg"
              alt="Principal"
              style={styles.principalImg}
            />
            <div style={styles.nameBox}>
              <h3>Mrs. Deepti Vadhera</h3>
              <p>Principal</p>
            </div>
          </div>

          {/* 📜 RIGHT CONTENT */}
          <div style={styles.card}>
            <h2 style={{ color: primaryColor }}>
              Principal's Message
            </h2>

            <p>
              Welcome to <b>Delhi Public Kids School</b> — a symbol of progressive,
              purposeful, and quality education.
            </p>

            <p>
              Our motto, <b>"We build the citizens of tomorrow,"</b> reflects our
              commitment to nurturing not just academic excellence but overall
              development in sports, arts, and co-curricular activities.
            </p>

            <p>
              Our school proudly offers activities like Football, Basketball,
              Cricket, Badminton, Skating, and more — shaping students into
              confident and active individuals.
            </p>

            <p>
              At the heart of our institution is a team of dedicated teachers
              who see teaching not just as a profession, but as a passion.
            </p>

            <p>
              Our aim is to make education joyful, meaningful, and value-based —
              ensuring every child grows with happiness and confidence.
            </p>

            <p style={{ marginTop: "20px", fontWeight: "600" }}>
              Mrs. Deepti Vadhera <br />
              Principal, Delhi Public Kids School, Ladwa
            </p>
          </div>

        </div>
      </div>
      
    </div>
  );
};

const styles = {
  
  hero: {
    width: "100%",
    marginTop: "clamp(80px, 10vw, 120px)", // 🔥 responsive
  },

  heroImageWrap: {
    position: "relative",
    width: "100%",
    height: "clamp(280px, 50vw, 560px)", // 🔥 FIXED HEIGHT → responsive
    overflow: "hidden",
    marginTop: "clamp(60px, 8vw, 140px)", // 🔥 responsive spacing
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },

  heroOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
  },

  heroContent: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "#fff",
    padding: "0 clamp(12px, 4vw, 20px)", // 🔥 responsive padding
  },

  heroTitle: {
    fontSize: "clamp(24px, 5vw, 48px)", // 🔥 responsive
    fontWeight: "800",
    marginBottom: "12px",
    maxWidth: "900px",
  },

  heroText: {
    maxWidth: "760px",
    fontSize: "clamp(13px, 2vw, 18px)", // 🔥 responsive
    opacity: 0.92,
  },
  container: {
    maxWidth: "1200px",
    margin: "auto",
    padding: "60px 20px",
  },
row: {
  display: "flex",
  gap: "50px",
  alignItems: "stretch",   // 🔥 center ki jagah stretch (match height)
  flexWrap: "wrap",
},
//   row: {
//     display: "flex",
//     gap: "50px",
//     alignItems: "center",
//     flexWrap: "wrap",
//   },

//   imageWrapper: {
//     position: "relative",
//     flex: "1",
//     minWidth: "280px",
//   },
imageWrapper: {
  position: "relative",
  flex: "1.2",   // 🔥 pehle 1 tha → ab image thodi badi hogi
  minWidth: "320px",
},
//   principalImg: {
//     width: "100%",
//     borderRadius: "20px",
//     boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
//   },
principalImg: {
  width: "100%",
  height: "100%",              // 🔥 full height lega
  minHeight: "420px",          // 🔥 content ke barabar feel
  objectFit: "cover",
  borderRadius: "20px",
  boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
},
  nameBox: {
    position: "absolute",
    bottom: "10px",
    left: "10px",
    background: "rgba(0,0,0,0.7)",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "10px",
  },

  card: {
    flex: "1.5",
    background: "#fff",
    padding: "35px",
    borderRadius: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    lineHeight: "1.8",
  },
};

export default PrincipalMessage;